function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect } from 'react';
import { useFormFieldWithSelector } from 'formydable';
import Button from 'react-bootstrap/Button';
import InputCore from './InputCore';
import Icon from '../Icon';
import { useFormManager } from './FormCore';

const FieldArray = ({
  name,
  immidiate,
  showAction,
  label,
  value,
  ...props
}) => {
  const {
    readonly
  } = useFormManager();
  const {
    fieldState,
    formUpdate,
    setFieldArray,
    setFieldArrays,
    removeFieldArray
  } = useFormFieldWithSelector(name, true);
  const defaultSchema = {
    label: label || name,
    rules: props.rules,
    value: ""
  };
  const states = fieldState;
  useEffect(() => {
    if (value && Array.isArray(value)) {
      setFieldArrays(name, value.map(each => {
        return { ...defaultSchema,
          value: each
        };
      }));
    }
  }, [value]);
  useEffect(() => {
    if (immidiate && !value) setFieldArray(name, defaultSchema);
    return () => removeFieldArray(name);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, states.map((state, index, array) => {
    const lastIndex = array.length - 1;
    return /*#__PURE__*/React.createElement(InputCore, _extends({
      key: index
    }, props, {
      name: `${name}[${index}]`,
      onChange: formUpdate,
      label: index === 0 ? label : undefined,
      state: state,
      iconAppend: readonly !== true && /*#__PURE__*/React.createElement("span", {
        title: index === lastIndex ? 'add more' : 'remove',
        className: "d-inline-flex align-items-center",
        style: {
          cursor: "pointer"
        },
        onClick: () => {
          if (index === lastIndex) {
            setFieldArray(name, defaultSchema);
          } else {
            removeFieldArray(name, index);
          }
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: index === lastIndex ? "plus" : "trash-alt"
      }))
    }));
  }), readonly !== true && (showAction && immidiate && states.length > 1 || !immidiate) && /*#__PURE__*/React.createElement(Button, {
    className: "mb-3",
    block: true,
    disabled: props.disabled,
    onClick: () => {
      if (states.length > 0) {
        removeFieldArray(name, immidiate ? 0 : undefined, immidiate);
      } else {
        setFieldArray(name, defaultSchema);
      }
    }
  }, states.length > 0 ? "REMOVE ALL" : `CREATE ${name.toLocaleUpperCase()}`));
};

FieldArray.defaultProps = {
  immidiate: true,
  showAction: true
};
export default FieldArray;